export default __webpack_public_path__ + "9aee96c85c4aefabe346b2f1f83afbe5.svg";